const textBase = {
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "18px",
  color: "#FFF",
};

const styles = {
  dataApp: {
    height: "60px",
    background: "#114B76",
    padding: 0,
    borderRadius: "5px 5px 0px 0px",
    boxShadow: "none",
    marginBottom: "12px",
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    minHeight: "60px",
  },
  headerContent: {
    ...textBase,
    flexShrink: 0,
  },
  email: {
    ...textBase,
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    textAlign: "right",
  },

};

export default styles;
